import { AxiosResponse } from "axios";
import { BASE_URL, NAV_URL, httpClient } from "../config/develop-config";
import { OrderPaymentStatusKey, OrderStatusKey } from "../definitions/orderStatus";

export const baseUrl = `${BASE_URL}/order-cart`;
// const baseUrl = "http://localhost:3030";

const getOrders = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/order`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

// SSE Connection for Real-time Order Updates
const createOrderSSEUrl = (params: any) => {
  const searchParams = new URLSearchParams();

  // Add all parameters to URL query string
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      if (Array.isArray(value)) {
        // Handle array parameters (like status, customerZones)
        value.forEach((item) => {
          if (item !== undefined && item !== null && item !== "") {
            searchParams.append(key, String(item));
          }
        });
      } else {
        searchParams.append(key, String(value));
      }
    }
  });

  const queryString = searchParams.toString();
  return `${baseUrl}/order/order-live${queryString ? `?${queryString}` : ""}`;
};

const getOrderDetail = async (id: string, withSpecialApprover?: boolean) => {
  return await httpClient
    .get(`${baseUrl}/order/${id}`, {
      params: { id, withSpecialApprover: withSpecialApprover ?? false },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getHistoryOrder = async (id: string) => {
  return await httpClient
    .get(`${baseUrl}/over-credit/history/${id}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const updateOrderStatus = async (data: {
  orderId: string;
  status?: OrderStatusKey;
  paidStatus?: OrderPaymentStatusKey;
  cancelRemark?: string;
  updateBy: string;
  reason?: string;
}) => {
  return await httpClient
    .post(`${baseUrl}/order/update-order-status`, data)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

const submitToNav = async (data: {
  orderId: string;
  remark?: string;
  updateBy?: string;
  assignedUserId?: string;
  docType?: string;
}) => {
  return await httpClient
    .post(`${NAV_URL}/sale-order`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getPdfPo = async (id: string, company: string) => {
  return await httpClient
    .post(
      `${baseUrl}/report-document/report-pdf-po/${id}/${company}`,
      {},
      {
        responseType: "arraybuffer",
      },
    )
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getOrdersNO = async (id: string) => {
  return await httpClient
    .get(`${baseUrl}/order/order-no/${id}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getPdfTicket = async (id: string, name: string) => {
  return await httpClient
    .post(
      `${baseUrl}/report-document/report-pdf-ticket/${id}/${name}`,
      {},
      {
        responseType: "arraybuffer",
      },
    )
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getInvoices = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/invoice/get-by-so`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const approveSoOrder = async (data: {
  orderId: string;
  userStaffId: string;
  action: string;
  updateBy: string;
  reason?: string;
}) => {
  return await httpClient
    .post(`${baseUrl}/order/approve-order-so`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

//#region Edit co
const getCoAvailableById = async (orderId: string) => {
  return await httpClient
    .get(`${baseUrl}/co-management/order/${orderId}/available-cos`, { params: { orderId } })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getCoUsedById = async (orderId: string) => {
  return await httpClient
    .get(`${baseUrl}/co-management/order/${orderId}/co`, { params: { orderId } })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const updateOrderCo = async ({
  params,
  orderId,
  updateBy,
}: {
  params: any;
  orderId: string;
  updateBy: string;
}) => {
  return await httpClient
    .patch(`${baseUrl}/co-management/order/${orderId}/allocations`, {
      updateBy,
      orderId,
      ...params,
    })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const addOrderCo = async ({
  params,
  orderId,
  updateBy,
}: {
  params: any;
  orderId: string;
  updateBy: string;
}) => {
  return await httpClient
    .post(`${baseUrl}/co-management/order/${orderId}/add-co`, {
      updateBy,
      orderId,
      ...params,
    })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const previewCoPercent = async (params: any) => {
  return await httpClient
    .post(`${baseUrl}/co-management/order/${params.orderId}/bill-pct/preview`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const updateCoPercent = async (params: any) => {
  return await httpClient
    .patch(`${baseUrl}/co-management/order/${params.orderId}/bill-pct`, {
      orderId: params.orderId,
      updateBy: params.updateBy,
      ...params,
    })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

//#endregion

const getOrderDiscount = async (orderId: string) => {
  const params = { orderId, withSpecialApprover: false };
  return await httpClient
    .get(`${baseUrl}/order/${params.orderId}/split-lines`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

export {
  getOrders,
  getOrderDetail,
  updateOrderStatus,
  submitToNav,
  getPdfPo,
  getOrdersNO,
  getPdfTicket,
  getInvoices,
  getHistoryOrder,
  createOrderSSEUrl,
  approveSoOrder,
  getCoAvailableById,
  getCoUsedById,
  updateOrderCo,
  addOrderCo,
  previewCoPercent,
  updateCoPercent,
  getOrderDiscount,
};
